export default __webpack_public_path__ + "static/media/Press-Release-August-03-2026.75774301.pdf";